import { render, staticRenderFns } from "./LuuTruList.vue?vue&type=template&id=63b6743c"
import script from "./LuuTruList.vue?vue&type=script&lang=js"
export * from "./LuuTruList.vue?vue&type=script&lang=js"
import style0 from "./LuuTruList.vue?vue&type=style&index=0&id=63b6743c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports